import type { GetUserPreferencesQuery } from '~/graphql/graphql';
import {
  isOrdersFilterData,
  isPricingFilterData,
  PRICING_FILTER_DATA_KEY,
} from '~/types';

export const FILTER_PERSPECTIVE = 'SELLING' as const;

type Preferences = GetUserPreferencesQuery['userPreferences'] | undefined;

export type MyProductsFilterView = 'INVENTORY' | 'PRICING';

export type MyProductsFilterViewConfig = {
  slot: 'inventory' | 'pricing';
  rowsKey: string;
  anonymousKey: 'sellerAnonymousFilter' | 'sellerPricingAnonymousFilter';
  activeIdOf: (preferences: Preferences) => string | null | undefined;
  anonymousOf: (preferences: Preferences) => unknown;
  isOwnFilterData: (filterData: unknown) => boolean;
  fields?: string[];
};

export const MY_PRODUCTS_FILTER_VIEWS: Record<
  MyProductsFilterView,
  MyProductsFilterViewConfig
> = {
  INVENTORY: {
    slot: 'inventory',
    rowsKey: 'sellerProductFilters',
    anonymousKey: 'sellerAnonymousFilter',
    activeIdOf: (preferences) => preferences?.sellerActiveFilterId,
    anonymousOf: (preferences) => preferences?.sellerAnonymousFilter,
    isOwnFilterData: (filterData) =>
      !isOrdersFilterData(filterData) && !isPricingFilterData(filterData),
  },
  PRICING: {
    slot: 'pricing',
    rowsKey: PRICING_FILTER_DATA_KEY,
    anonymousKey: 'sellerPricingAnonymousFilter',
    activeIdOf: (preferences) => preferences?.sellerPricingActiveFilterId,
    anonymousOf: (preferences) => preferences?.sellerPricingAnonymousFilter,
    isOwnFilterData: isPricingFilterData,
    fields: ['productCode', 'productName', 'length', 'dimensions'],
  },
};
